export default function formatCurrency(fee) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(Number(fee || "0"));
}
